import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { IsOptional, validateIf } from '@pristine-ts/class-validator';
import { ValidationGroupEnum } from '../../../../../enums/validation-group.enum';
import { clonePropertyMetadata } from '@pristine-ts/metadata';
import {
  CorporateIncomeTaxQuebecInCorporateIncomeTaxOptions,
} from '../../../income-tax/corporate/corporate/corporate-income-tax-quebec-in-corporate-income-tax.options';
import {
  CorporateIncomeTaxQuebecOptions,
} from '../../../income-tax/corporate/quebec/corporate-income-tax-quebec.options';

@translationBaseKey('income-tax-corporation-quebec-in-salary-dividend-options')
export class CorporateIncomeTaxQuebecInSalaryDividendOptions implements Omit<CorporateIncomeTaxQuebecInCorporateIncomeTaxOptions,
  'taxableIncomeOutsideCanada' |
  'propertyIncomeExceptCapitalGain'
> {

  @clonePropertyMetadata<CorporateIncomeTaxQuebecOptions>(CorporateIncomeTaxQuebecOptions, 'currentPaidHours')
  currentPaidHours: number;
  //heuresRemunereesActuelles

  @clonePropertyMetadata<CorporateIncomeTaxQuebecOptions>(CorporateIncomeTaxQuebecOptions, 'previousPaidHours')
  @validateIf((object: CorporateIncomeTaxQuebecInSalaryDividendOptions, root, currentPath) => object.isManufacturingSectorActivity === false)
  previousPaidHours: number;
  //heuresRemunereesPrecedentes

  @clonePropertyMetadata<CorporateIncomeTaxQuebecOptions>(CorporateIncomeTaxQuebecOptions, 'isManufacturingSectorActivity')
  isManufacturingSectorActivity: boolean;
  //activite_secteur_manufacturier
}
